<template>
<div id="auditoria_abonos_cargos_clave_documento" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="CONFRONTA VALOR PEDIMENTOS VS TXT" class="elevation-1 px-5 py-3" >
          <br>
            
              <div class="contenedor-tab-reportes">
                <v-card-text>
                  <v-card-subtitle>
                    <small class="red--text">*Los campos de “FECHA” requeridos para este módulo, se refieren a un periodo definido por rango (ejemplo: del 01-enero-2015 al 31-diciembre-2018).</small>
                  </v-card-subtitle>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col sm="12" md="4" lg="4">
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="4" lg="4">
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>   
                        <v-col sm="12" md="4" lg="4">
                            <v-autocomplete  v-model="model.presentacion" :items="presentaciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Periodo de Presentación">
                            </v-autocomplete>
                        </v-col>                    
                      </v-row>
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="success" @click="generar_reporte_sqs">
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-refresh-button :funcion="cargar"/>
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-1 pa-2">
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props">
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)">
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)">
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>                    

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <LoaderFraces ref="fracesLoader" :mensajes="lista_mensajes"></LoaderFraces>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
import LoaderFraces from "@/components/LoaderFraces";

var colors_bars = [
    "#08c1ff",
    "#f8cddb",
    "#fffac8",
    "#f4b58f",
    "#eed68f",
    "#aa9499",
    "#aaf0d1",
    "#b2fba5",
    "#ff6961",
    "#ff9899",
    "#ca9bf7"
];

export default {
  components: {
    "v-refresh-button": RefreshButton,
    LoaderFraces
  },
  created: function() {
        let self = this;
        var f_a = new Date();

        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();
       
        if (m < 10)
            m = '0' + m;
        if (d < 10)
            d = '0' + d;

        let fecha = y + "-" + m + "-" +d ;
        this.model.fecha_de = '2015-01-01';
        this.model.fecha_de_a = '2015-01-01';
        this.model.fecha_a = fecha;
        this.model.fecha_a_a = fecha;


    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;
    this.tipo_div = 1;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");
    if (this.planta_referencia)
            this.cargarPlantas();
    //this.consultaPorcentajes();
    this.cargar();
  },
  computed: {

        planta_referencia() {
            return this.$local_storage.get("Modulo16") == 100;
        },

  },
  data: () => ({
    tipo_div:1,
    lista_mensajes: [
            "ESTAMOS PROCESANDO EL PANEL PRINCIPAL..",
            "AGRADECEMOS SU PACIENCIA..",
            "GESTIONANDO INDICADORES DE VALOR..",
            "VERIFICANDO PORCENTAJES DE RETORNO..",
            "ANALIZANDO VALORES POR PERIODO.."
        ],
    meses: ['', 'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
    data_tableA: [],
    destinos_aduaneros_cargos: ['IN', 'V1', 'E1'],
    destinos_aduaneros_abonos: ['RT', 'V1', 'CTM', 'BM', 'BO', 'L1', 'H1', 'H8', 'A1'],
    permisoEliminar:false,
    planta: '',
    tipo_periodo: 'Mensual',
        fab: false,
        plantas: [],
        columns_tableA: [
            "ejercicio",
            "cargos",
            "abonos",
            "porcentaje",

        ],
        tableA_options: {
            filterable: false,
            filterByColumn: false,
            sortable: [],
            perPage: 100,
            texts: {
                count: ''
            },
            headings: {
                "ejercicio": "EJERCICIO",
                "cargos": "CARGOS",
                "abonos": "ABONOS",
                "porcentaje": "PORCENTAJE",

            }
        },
        data_grafica1: {
            chart: {
                type: "column",
                backgroundColor: null,
                height: 250,
                spacingBottom: 2,
                spacingTop: 2,
                spacingLeft: 2,
                spacingRight: 2,
                marginRight: 2,
                marginLeft: 40,
                marginTop: 2,
                marginBottom: 30,

            },
            credits: {
                enabled: false
            },
            csecondaryits: false,
            title: {
                text: ""
            },

            navigator: {
                yAxis: {
                    gridLineColor: '#000'
                }
            },
            colors: colors_bars,
            xAxis: {
                categories: [],
                gridLineWidth: 1,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },

            },

            yAxis: {
                allowDecimals: false,
                gridLineWidth: 1,
                minorGridLineWidth: 1,
                minorTicks: true,
                min: 0,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },
            },

            tooltip: {
                formatter: function () {
                    return false;
                    return (
                        "% " + this.y
                    );
                }
            },

            plotOptions: {
                candlestick: {
                    lineColor: 'secondary'
                },
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.1f}%'
                    }
                }
            },
            legend: {
                enabled: false
            },
            series: []
        },
    valoraciones: [{
            "id": "EJERCICIO FISCAL"
        }, {
            "id": "ULTIMOS 12 MESES"
        }],
        valoracion: "EJERCICIO FISCAL",
        presentaciones: [{
            "id": "MENSUAL"
        }, {
            "id": "BIMESTRAL"
        }],
        presentacion: "MENSUAL",
    list_activos:[
        {"id":"N","text":"No"}, //No Activo Fijos
        {"id":"S","text":"Si"}, //Activo Fijo
        {"id":"","text":"Todos"}],
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Auditorías",
        disabled: true,
        to: ""
      },
      {
        text: "Confronta Pedimentos vs TXT",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    listado:"",
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      presentacion:"MENSUAL",            
      reporte_url: "",
      nombre_reporte: "",
      tipo: "",
      
    },
    presentaciones: [{
            "id": "MENSUAL"
        }, {
            "id": "BIMESTRAL"
        }],
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,

  }),
  methods: {
    cargarPlantas: async function () {

        let data = {
            cliente: this.$local_storage.get("id_cliente"),
        };
        await axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data)
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.plantas = res.data;

                }
            })
            .catch(err => {
                console.log();
            });
    },
    formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
    consultaPorcentajes: function () {

          this.$refs.fracesLoader.show('ESPERE UN MOMENTO POR FAVOR ..');
          let self = this;
          let total_cargos = 0;
          let total_abonos = 0;

          this.data_tableA = [];
          let data_cargos = {
              rfc: this.$local_storage.get("rfc"),
              fecha_cargo: this.model.fecha_a,
              fecha_de: this.model.fecha_de,
              destinos: this.model.destinos_cargos 
          };
          let data_abonos = {
              rfc: this.$local_storage.get("rfc"),
              fecha_abono: this.model.fecha_a_a,
              fecha_de: this.model.fecha_de_a,
              destinos: this.model.destinos_abonos
          };
          if (this.planta != '') {
              data_cargos = {
                  rfc: this.$local_storage.get("rfc"),
                  fecha_cargo: this.model.fecha_a,
                  fecha_de: this.model.fecha_de,
                  destinos: this.model.destinos_cargos,
                  planta: this.planta
              }
              data_abonos = {
                  rfc: this.$local_storage.get("rfc"),
                  fecha_abono: this.model.fecha_a_a,
                  fecha_de: this.model.fecha_de_a,
                  destinos: this.model.destinos_abonos,
                  planta: this.planta
              }

          }

          if (this.valoracion == 'EJERCICIO FISCAL') {
              axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_anio/", data_cargos)
                  .then(res => {
                      if (typeof res.data !== "undefined") {
                          let cargos = res.data;
                          cargos = res.data.sort(function (a, b) {
                              return parseInt(b.anio) - parseInt(a.anio);
                          });
                          console.log(cargos);
                          axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_anio/", data_abonos)
                              .then(res => {
                                  if (typeof res.data !== "undefined") {
                                      cargos.forEach(function (c) {
                                          self.data_tableA.push({
                                              "ejercicio": c.anio,
                                              "cargos": parseInt(c.valor),
                                              "abonos": "0",
                                              "porcentaje": "0",

                                          });
                                      });
                                      let abonos = res.data;
                                      abonos.forEach(function (a) {
                                          let encontrado = self.data_tableA.filter(item => {
                                              return item.ejercicio == a.anio
                                          });

                                          if (encontrado.length > 0) {
                                              encontrado[0].abonos = parseInt(a.valor);
                                              encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                          } else {
                                              self.data_tableA.push({
                                                  "ejercicio": a.anio,
                                                  "cargos": "0",
                                                  "abonos": parseInt(a.valor),
                                                  "porcentaje": "0",

                                              });
                                          }

                                      });
                                      self.llenarGrafica1();

                                  }
                              })
                              .catch(err => {
                                  console.log(err);
                                  this.loading = false;
                              }).then(res => {
                                  this.dialog = false;
                                  this.loading = false;
                                  this.$refs.fracesLoader.hide();
                              });

                      }
                  })
                  .catch(err => {
                      console.log(err);
                      this.loading = false;
                  }).then(res => {
                      this.dialog = false;
                      this.$refs.fracesLoader.hide();
                  });

          } else {
              axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_mes/", data_cargos)
                  .then(res => {
                      if (typeof res.data !== "undefined") {
                          let cargos = res.data;

                          axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_mes/", data_abonos)
                              .then(res => {
                                  if (typeof res.data !== "undefined") {

                                      let abonos = res.data;
                                      cargos.forEach(function (c) {
                                          if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES") {
                                              if (c.mes % 2 == 0) {
                                                  self.data_tableA.push({

                                                      "ejercicio": c.anio + '-' + self.meses[c.mes - 1] + '-' + self.meses[c.mes],
                                                      "cargos": parseInt(c.valor),
                                                      "abonos": "0",
                                                      "porcentaje": "0",

                                                  });
                                                  total_cargos += parseInt(c.valor);
                                              } else {
                                                  let encontrado2 = self.data_tableA.filter(item => {
                                                      return item.ejercicio == c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1]
                                                  });

                                                  if (encontrado2.length > 0) {
                                                      encontrado2[0].cargos = parseInt(encontrado2[0].cargos) + parseInt(c.valor);
                                                      encontrado2[0].porcentaje = parseInt((parseFloat(encontrado2[0].abonos) / parseFloat(encontrado2[0].cargos)) * 100);
                                                      total_cargos += parseInt(c.valor);
                                                  } else {
                                                      self.data_tableA.push({

                                                          "ejercicio": c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1],
                                                          "cargos": parseInt(c.valor),
                                                          "abonos": "0",
                                                          "porcentaje": "0",

                                                      });
                                                      total_cargos += parseInt(c.valor);
                                                  }

                                              }

                                          } else {
                                              total_cargos += parseInt(c.valor);
                                              self.data_tableA.push({

                                                  "ejercicio": c.anio + '-' + self.meses[c.mes],
                                                  "cargos": parseInt(c.valor),
                                                  "abonos": "0",
                                                  "porcentaje": "0",

                                              });
                                          }

                                      });
                                      abonos.forEach(function (a) {

                                          if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES") {
                                              if (a.mes % 2 == 0) {
                                                  let encontrado = self.data_tableA.filter(item => {
                                                      return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes - 1]
                                                  });

                                                  if (encontrado.length > 0) {
                                                      encontrado[0].abonos = parseInt(encontrado[0].abonos) + parseInt(a.valor);
                                                      encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                      total_abonos += parseInt(a.valor);
                                                  }
                                              } else {
                                                  let encontrado = self.data_tableA.filter(item => {
                                                      return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes + 1]
                                                  });

                                                  if (encontrado.length > 0) {
                                                      encontrado[0].abonos = parseInt(a.valor);
                                                      encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                      total_abonos += parseInt(a.valor);
                                                  }
                                              }
                                          } else {
                                              let encontrado = self.data_tableA.filter(item => {
                                                  return item.ejercicio == a.anio + '-' + self.meses[a.mes]
                                              });

                                              if (encontrado.length > 0) {
                                                  total_abonos += parseInt(a.valor);
                                                  encontrado[0].abonos = parseInt(a.valor);
                                                  encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                              }
                                          }

                                      });
                                      self.llenarGrafica1();
                                      if (self.valoracion == "ULTIMOS 12 MESES") {
                                          self.data_tableA.push({

                                              "ejercicio": 'TOTAL',
                                              "cargos": total_cargos,
                                              "abonos": total_abonos,
                                              "porcentaje": parseInt((total_abonos / total_cargos) * 100),

                                          });
                                      }

                                  }
                              })
                              .catch(err => {
                                  console.log(err);
                                  this.loading = false;
                              }).then(res => {
                                  this.dialog = false;
                                  this.loading = false;
                                  this.$refs.fracesLoader.hide();
                              });

                      }
                  })
                  .catch(err => {
                      console.log(err);
                      this.loading = false;
                  });
          }

          },
    async llenarGrafica1() {
          let self = this;
          let data = [];
          self.data_grafica1.xAxis.categories = [];
         
          self.data_grafica1.xAxis.categories = [];
          self.data_tableA.forEach(function (x) {
              data.push({
                  y: parseInt(x.porcentaje),
                  name: x.ejercicio
              })
              self.data_grafica1.xAxis.categories.push(x.ejercicio);
          });

          self.data_grafica1.series[0] = {
              data: data,
              colorByPoint: true
          };

          },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: 'SA31_Confronta_PedTXT'
      };
      axios.post(this.$apiSA31 + "soluciona31/reportes/get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud)
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminados(this.datos[k].criterio);
            }
          }
        })
        .catch(err => {

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores",
        "No Recuperable", "Token Incorrecto", "Reprogramado", , "Pendiente AA"
      ];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);

            if (params.lista != undefined && params.lista.length > 0) {
              return "Buscado por lista de pedimentos: " + params.lista.length;
            } else if (params.numero_pedimento && params.numero_pedimento != ""){
              return "Pedimento: " + params.numero_pedimento;
            }else {
              var txt = "";
              if (params.fecha_de && params.fecha_de != "")
                  txt += "De: " + params.fecha_de+" ";
              if (params.fecha_a && params.fecha_a != "")
                  txt += " A: " + params.fecha_a+", ";
              if (params.presentacion && params.presentacion != "")
                  txt += " " + params.presentacion+" ";              
              return txt;
            }


        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    validaDiasPreview: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    formatNumberDec: function(numero, decimales){
        if (numero == undefined || numero == null || numero == "")
            numero = 0;
        numero = Number(numero);
        if (isNaN(numero)){
            return "";
        } else
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;

        data['reporte_url'] =  "/soluciona31/reportes/auditoria_clave_documento/";
        data['nombre_reporte'] = "Confronta Pedimentos vs TXT";
        data['tipo'] = "SA31_Confronta_PedTXT";
        data.fecha_de = this.model.fecha_de;
        data.fecha_a = this.model.fecha_a;
                
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",            
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.cargar(this.tipo_div);
            this.$root.$dialogLoader.hide();
          });
      }
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },


  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>
